@let uploads = uploadService.queue |async;
<div class="row" *ngIf="uploads.length > 0" style="height: 400px">
  <div class="col-12">
    <sb-card>
      <div card-header>
        <h2>
          <sb-icon icon="uploadAlt" class="mr-2"></sb-icon>
          {{ 'lang.mediumExplorer.uploading'|translate }}
        </h2>
      </div>
      <div card-body>
        <ng-scrollbar style="overflow-x: auto; height: 260px">

          <table class="table">
            <thead>
            <tr>
              <th class="sticky-top tableBg">Status</th>
              <th class="sticky-top tableBg">Name</th>
              <th class="sticky-top tableBg"></th>
            </tr>
            </thead>
            <tbody>
              @for (upload of uploads; track $index) {
                <tr>
                  <td>
                    <div class="d-flex align-items-center">
                      @switch (upload.status) {
                        @case ('Started') {
                          <div>
                            <sb-icon [animationOptions]="options" [dualColor]="true" icon="uploadAltAnimation"></sb-icon>
                          </div>
                          <div class="font-weight-bold black">
                            {{ 'lang.upload.uploading' | translate }}...
                          </div>

                        }
                        @case ('NotStarted') {
                          <div>
                            <sb-icon [dualColor]="true" icon="plus"></sb-icon>
                          </div>
                          <div class="font-weight-bold black">
                            {{ 'lang.upload.fileInQueue' | translate }}
                          </div>

                        }
                        @case ('Uploaded') {
                          <div>
                            <sb-icon [dualColor]="true" icon="setting"></sb-icon>
                          </div>
                          <div class="font-weight-bold black">
                            {{ 'lang.upload.processing' | translate }}...
                          </div>
                        }
                        @case ('Done') {
                          <div>
                            <sb-icon [dualColor]="true" icon="fileCompleted"></sb-icon>
                          </div>
                          <div class="font-weight-bold black">
                            {{ 'lang.upload.successful' | translate }}
                          </div>
                        }
                        @case ('Error') {
                          <div>
                            <sb-icon [dualColor]="true" icon="fileError"></sb-icon>
                          </div>
                          <div class="font-weight-bold black">
                            {{ 'lang.upload.unsuccessful' | translate }}
                          </div>
                        }
                        @case ('UserInteraction') {
                          <div>
                            <sb-icon [dualColor]="true" icon="questionmark"></sb-icon>
                          </div>
                          <div class="font-weight-bold black">
                            {{ 'lang.upload.userAction' | translate }}
                          </div>
                        }
                      }
                    </div>
                  </td>
                  <td>{{ upload?.file?.name }}</td>
                  <td class="tr">
                    <button class="btn btn-danger" type="button" (click)="uploadService.removeFile(upload)">
                      @if (upload.status === 'Started') {
                        <sb-icon icon="cancel"></sb-icon>
                      } @else {
                        <sb-icon icon="trash"></sb-icon>
                      }
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </ng-scrollbar>
      </div>
      <!-- Card view-->
      <!--
      <div card-fit class="d-flex" style="overflow-x: scroll">
        <sb-card *ngFor="let upload of uploads" [classes]="'noShadow'">
          <div card-fit classes="h-100" style="height: 100%; width: 200px">
            <div class="d-flex justify-content-center align-items-center"
                 style="height: 100%;width: 100%;display: flex;flex-direction: column; padding: 1rem;">
              <ng-container *ngIf="upload?.status === 0">
                <div style="font-size: 4rem;">
                  <sb-icon [dualColor]="true" icon="plus"></sb-icon>
                </div>
                <h5 class="pt-5 d-flex justify-content-center">
                  {{'lang.globals.newFile' | translate}}
                </h5>
              </ng-container>
              <ng-container *ngIf="upload?.status === 1">
                <div style="font-size: 4rem;">
                  <sb-icon [animationOptions]="options" [dualColor]="true" icon="uploadAltAnimation"></sb-icon>
                </div>
                <h5 class="pt-5 d-flex justify-content-center">
                  {{'lang.globals.uploadFiles' | translate}}...
                </h5>
              </ng-container>
              <ng-container *ngIf="upload?.status === 2">
                <div style="font-size: 4rem;">
                  <sb-icon [dualColor]="true" icon="setting"></sb-icon>
                </div>
                <h5 class="pt-5 d-flex justify-content-center">
                  {{'lang.globals.processing' | translate}}
                </h5>
              </ng-container>
              <ng-container *ngIf="upload?.status === 3">
                <div style="font-size: 4rem;">
                  <sb-icon [dualColor]="true" icon="fileCompleted"></sb-icon>
                </div>
                <h5 class="pt-5 d-flex justify-content-center">
                  {{'lang.globals.successful' | translate}}
                </h5>
              </ng-container>
              <ng-container *ngIf="upload?.status === -1">
                <div style="font-size: 4rem;">
                  <sb-icon [dualColor]="true" icon="fileError"></sb-icon>
                </div>
                <h5 class="pt-5 d-flex justify-content-center">
                  {{'lang.globals.unSuccessful' | translate}}
                </h5>
              </ng-container>
            </div>
          </div>
        </sb-card>
      </div>
      -->
    </sb-card>
  </div>
</div>
